import CRUDgeneric from 'utils/CRUDgeneric';
import makeTree from 'utils/makeTree';

export const URIclavePresupuestalEgresos = '/configuraciones/clave-presupuestal-egresos/'; // Form
export const URIclavePresupuestalEgresosConceptosDeEgreso = '/contabilidad/clasificaciones-objeto-gasto-egresos/'; // miniTabla
export const URIclavePresupuestalEgresosConceptosDeEgresoPut = '/configuraciones/claves-presupuestales-de-egreso-agregar-cog/';

export const CRUDclavePresupuestalEgresos = CRUDgeneric(URIclavePresupuestalEgresos);
export const CRUDclavePresupuestalEgresosConceptosDeEgreso = CRUDgeneric(
  URIclavePresupuestalEgresosConceptosDeEgreso,
);

// Empaqueto todo en un objeto
/** permite llamarlo facilmente por el editor */
export const ModelClavesPresupuestalesDeEgreso = {
  nameModel: 'Claves Presupuestales',
  nameModelSingular: 'la clave presupuestal',
};

// Empaqueto todo en un objeto
/** permite llamarlo facilmente por el editor */
export const ModelClavesPresupuestalesDeIngresoConceptosDeEgreso = {
  nameModel: 'Concepto de Egreso',
  nameModelSingular: 'el Concepto de Egreso',
};

const _normalizeCog = (_data = []) => _data.map((item) => {
  const clone = { ...item };
  const children = clone.children?.length && typeof clone.id === 'string'
    ? _normalizeCog(clone.children) : [];
  if (!children.length || typeof clone.id === 'number') {
    delete clone.children;
    return ({
      ...clone,
      key: clone.clave,
      clave: clone.clave,
      disabled: !clone.seleccionable,
    });
  }
  return ({
    ...clone,
    key: clone.clave,
    children,
    disabled: !clone.seleccionable,
  });
});

/// solo funciona si el value es:
// const currentPath = `${parentPath}-${clone.id}-${index}`;
export const extractIdsCog = (value) => {
  const extract = (v) => {
    if (typeof v !== 'string') return v;

    if (!v.includes('-')) return v;

    const parts = v.split('-');
    return parts[parts.length - 2];
  };

  if (Array.isArray(value)) {
    return value.map(extract);
  }

  return extract(value);
};

const _normalizeDataCog = (
  data,
  prop = 'concepto',
  parentPath = 'root',
) => {
  if (!data?.length) return [];

  return data.map((item, index) => {
    const clone = { ...item };

    const currentPath = `${parentPath}-${clone.id}-${index}`;

    const children = _normalizeDataCog(
      clone.children,
      prop,
      currentPath,
    );

    const isLeaf = !children.length;

    return {
      key: currentPath,
      value: currentPath,
      id: clone.id,
      title: `${item.clave} - ${item[prop]}`,
      disabled: isLeaf ? item?.disabled : true,
      ...(children.length && { children }),
    };
  });
};

export const normalizeCog = (tree) => _normalizeDataCog(_normalizeCog(tree));
/// usar cog union, de lo contrario no funcionara
export const makeTreeCog = (data) => makeTree(data.map((e) => (!e.seleccionable ? ({
  ...e,
  id: `${e.id}`,
}) : e)).sort((a, b) => a.id - b.id));

export const mapWithKeys = (_data = []) => _data.map((item) => ({
  id: item.id,
  key: item.id,
  value: item.id,
  title: item ? `${item.clave} - ${item.concepto}` : '',
  seleccionable: false,
  children: item.children ? mapWithKeys(item.children) : undefined,
}));
